import getComponentInstanceFor from '@swey/vue-hydration/getComponentInstanceFor';

/**
 * LayoutUtil
 */
export default class LayoutUtil {
	private static scrollPositionSnapshot: number | null = null;

	/**
	 * Makes the l-main container unscrollable and saves its current position
	 * for the resetting.
	 */
	public static deactivateMainContainer(): void {
		const mainWrapper: HTMLElement | null = document.querySelector('.l-main');
		const logo = document.querySelector('.m-header__logo-wrapper');

		if (mainWrapper) {
			LayoutUtil.scrollPositionSnapshot = window.pageYOffset;
			mainWrapper.classList.add('is-unscrollable');
			mainWrapper.scrollTo(0, LayoutUtil.scrollPositionSnapshot);
			mainWrapper.setAttribute('aria-hidden', 'true');
		}

		if (logo) {
			logo.classList.add('is-hidden');
		}
	}

	/**
	 * Makes the l-main container scrollable again and resets the scroll position
	 * to the previous one.
	 */
	public static activateMainContainer(): void {
		const mainWrapper: HTMLElement | null = document.querySelector('.l-main');
		const logo = document.querySelector('.m-header__logo-wrapper');

		if (mainWrapper && LayoutUtil.scrollPositionSnapshot !== null) {
			mainWrapper.classList.remove('is-unscrollable');
			mainWrapper.style.removeProperty('top');
			window.scrollTo(0, LayoutUtil.scrollPositionSnapshot);
			LayoutUtil.scrollPositionSnapshot = null;
			mainWrapper.setAttribute('aria-hidden', 'false');
		}

		if (logo) {
			logo.classList.remove('is-hidden');
		}
	}

	/**
	 * Hide and disables scroll behavior of navigation for an certain amount of time
	 */
	public static disableNavigationAndExecuteCallback(callback?: () => void): void {
		const header: HTMLElement | null = document.querySelector('.m-header');
		if (header) {
			const headerComponent = getComponentInstanceFor(header) as any;

			if (headerComponent) {
				headerComponent.ignoreScrollEvent = true;
				headerComponent.moveNavigationBarOut();

				setTimeout((): void => {
					headerComponent.ignoreScrollEvent = false;
				}, 1200);
			}
		}

		if (callback) {
			callback();
		}
	}

	/**
	 * Scrolls an element to top of viewport and forces Navigation not to show despite scroll movement
	 */
	public static scrollElementToTopAndHideNavigation(element: HTMLElement, offset: number = 0): void {
		const scrollPosition = element.getBoundingClientRect().top + window.pageYOffset - offset;

		LayoutUtil.disableNavigationAndExecuteCallback((): void => {
			window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
		});
	}
}
